import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { SafeValue } from 'src/core-lib/pipes/models/safe-value.enum';
import { UmbracoMediaType } from 'src/core-lib/umbraco/umbraco-media-types.enum';
import { UmbracoEmbeddedVideo, UmbracoVideo } from 'src/core-lib/umbraco/umbraco-video.model';
import { Uuid } from 'src/utils/uuid.util';
import { SettingsSetterDirective } from '../../models/general-element-settings';


@Component({
    selector: 'app-video-element',
    templateUrl: './video-element.component.html',
    styleUrls: ['./video-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoElementComponent extends SettingsSetterDirective implements OnInit {
    id = Uuid.create();
    link: UmbracoVideo | UmbracoEmbeddedVideo;
    caption?: string;
    @HostBinding('attr.size') size?: 'Small' | 'Fit' | 'Large' = 'Fit';
    @HostBinding('style.background') backgroundImage?: string;
    SafeValue = SafeValue;
    UmbracoMediaType = UmbracoMediaType;

    constructor(private changeDetector: ChangeDetectorRef, elm: ElementRef, _detector: ChangeDetectorRef) {
        super(elm, _detector);
    }

    ngOnInit() {
        this.backgroundImage = `url(${this.link?.poster})`;
        super.ngOnInit();
        this.aspectRatio = null;
        setTimeout(() => this.changeDetector.markForCheck(), 100);
    }

    removePoster(id?: string | number) {
        if (id == null)
            return;
        var elm = window[id] as HTMLElement;
        if (elm.hasAttribute('poster')) {
            elm.removeAttribute('poster');
            if (this.link?.type === UmbracoMediaType.EmbeddedVideo) {
                let src = new URL(this.link['src']);
                src.searchParams.set('autoplay','1');
                var __src = src.href.replace('www.youtube.com', 'www.youtube-nocookie.com');
                this.link['src'] = __src;

            }
        }
    }
}
